import React, { Component } from "react";
import propTypes from "prop-types";
import { connect } from "react-redux";

import * as actions from "../../actions/index";
import icons from "../../data/icons";
import Button from "../Button/Button";
import DisclaimerBox from "../DisclaimerBox/DisclaimerBox";
import Group from "../Group/Group";
import Loader from "../Loader/Loader";
import MediaContainer from "../MediaContainer/MediaContainer";
import appData from "../../data/app.json";

import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playGif: false
    };
    this.appShellRef = React.createRef();
    this.goBack = this.goBack.bind(this);
  }
  goBack() {
    this.appShellRef.current.className = "app__shell fadeOut";
    this.props.goToGroup(appData.groups[this.props.currentGroup].parentID);
    this.props.goBack();
    setTimeout(() => {
      this.appShellRef.current.className = "app__shell fadeOut fadeIn";
    }, 200);
  }
  render() {
    let isMobile = window.innerWidth <= 760;
    return (
      <main className={"app"}>
        <section
          ref={this.appShellRef}
          className={
            !this.appShellRef ||
            !this.appShellRef.current ||
            this.appShellRef.current.className !== ""
              ? "app__shell"
              : this.appShellRef.current.className
          }
        >
          <MediaContainer
            groupData={appData.groups[this.props.currentGroup]}
            mediaData={this.props.mediaData}
            currentGroup={this.props.currentGroup}
            allVideoTransitionsLoaded={this.props.allVideoTransitionsLoaded}
            allVideoLoopsLoaded={this.props.allVideoLoopsLoaded}
            allImagesLoaded={this.props.allImagesLoaded}
          />
          {appData.groups[this.props.currentGroup] && (
            <Group
              key={`group-${appData.groups[this.props.currentGroup].groupID}`}
              groupID={appData.groups[this.props.currentGroup].groupID}
              data={appData.groups[this.props.currentGroup]}
              currentStage={this.props.currentStage}
              currentGroup={this.props.currentGroup}
            />
          )}

          {this.props.currentGroup !== "Home" &&
            (isMobile || !this.props.navigationWait) && (
              <Button
                onClick={() => this.goBack()}
                className={"button__goBack"}
                icon={icons.arrow.svg}
              >
                Go back
              </Button>
            )}
        </section>
        <DisclaimerBox />
        <Loader
          allImagesLoaded={this.props.allImagesLoaded}
          progress={this.props.progress}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    backToParent: state.navigation.backToParent,
    currentGroup: state.navigation.currentGroup,
    currentStage: state.navigation.currentStage,
    groupDirection: state.navigation.groupDirection,
    pathname: state.router.location.pathname,
    appReady: state.media.appReady,
    navigationWait: state.navigation.navigationWait
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goBack: () => {
      dispatch(actions.goBack());
    },
    goToGroup: groupID => {
      dispatch(actions.goToGroup(groupID));
    },
    unsetNavigationWait: () => {
      dispatch(actions.unsetNavigationWait());
    }
  };
}

App.propTypes = {
  currentGroup: propTypes.string.isRequired,
  currentStage: propTypes.number,
  pathname: propTypes.string.isRequired,
  appReady: propTypes.bool.isRequired,
  navigationWait: propTypes.bool.isRequired,
  imageData: propTypes.shape({
    src: propTypes.string.isRequired,
    alt: propTypes.string.isRequired
  })
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
